import { Transaction } from "@finway-group/shared/lib/models"
import { useQuery } from "@tanstack/react-query"
import { queryClient } from "~Shared/config/reactQueryConfig"
import { CacheEnum } from "~Shared/queries/consts"
import { TransactionService } from "~Shared/services"

export const useTransaction = (transactionId: string) =>
    useQuery({
        queryKey: [CacheEnum.TRANSACTIONS, transactionId],
        queryFn: () => TransactionService.fetchOneMatchingTransaction(transactionId),
        select: (transaction: Transaction) => new Transaction(transaction),
        enabled: Boolean(transactionId),
    })

export const invalidateTransaction = (transactionId: string) =>
    queryClient.invalidateQueries({
        queryKey: [CacheEnum.TRANSACTIONS, transactionId],
    })

export const invalidateTransactions = () =>
    queryClient.invalidateQueries({
        queryKey: [CacheEnum.TRANSACTIONS],
    })
